import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { adminApiClient } from "../../lib/adminApiClient";
import { queryKeys } from "../../lib/queryClient";
import { ErrorBanner, LoadingState } from "../../components/States";
import { formatDateTime } from "../../lib/format";

export function AdminPostsPage() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.adminPosts,
    queryFn: () => adminApiClient.listPosts({ limit: 100 }),
  });

  return (
    <div className="stack">
      <div className="row row--between">
        <div>
          <h1>Blog posts</h1>
          <p className="muted text-sm">
            Admin-authored articles shown on the public <code>/blog</code> page. A DRAFT post is
            never visible there — only PUBLISHED ones are.
          </p>
        </div>
        <Link to="/admin/posts/new" className="btn btn-primary">
          New post
        </Link>
      </div>

      {isLoading && <LoadingState label="Loading posts…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && (
        <div style={{ overflowX: "auto" }}>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Status</th>
                <th>Published</th>
                <th>Updated</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {data.items.map((post) => (
                <tr key={post.id}>
                  <td>{post.title}</td>
                  <td>
                    <span
                      className={
                        post.status === "PUBLISHED" ? "badge badge--success" : "badge"
                      }
                    >
                      {post.status}
                    </span>
                  </td>
                  <td>{post.publishedAt ? formatDateTime(post.publishedAt) : "—"}</td>
                  <td>{formatDateTime(post.updatedAt)}</td>
                  <td>
                    <Link to={`/admin/posts/${post.id}`} className="btn btn-secondary btn-sm">
                      Edit
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {data.items.length === 0 && <p className="muted">No posts yet.</p>}
        </div>
      )}
    </div>
  );
}
